// src/App.js
import React from 'react';
import './App.css';
import Navbar from './components/navbar';
import NavDrawer from './components/navDrawer';
import Menu from './components/menu';
import Checkout from './components/checkout';
import Voucher from './components/voucher';
import ReservationPage from './components/reservation/ReservationPage';
import ProductDetails from './components/ProductDetails';
import CssBaseline from '@mui/material/CssBaseline';

import Theme from './themeConfig';
import backgroundImage from './asset/paperBackground.jpg';
import { GoogleMapsProvider } from './context/gmapscontext';
import { UserProvider } from './context/userContext';
import { CatalogProvider } from './context/catalogContext';
import { OrderProvider } from './context/orderContext';

import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';

import {
  StyledEngineProvider,
  ThemeProvider,
  Toolbar,
  Box,
} from '@mui/material';

const drawerWidth = 240;

function App() {
  const [isOpenDrawer, setIsOpenDrawer] = React.useState(false);

  return (
    <Box sx={{ display: 'flex' }}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={Theme}>
          <UserProvider>
            <OrderProvider>
              <CatalogProvider>
                <GoogleMapsProvider>

                  {/* Root */}
                  <Router>
                    {/* Navbar y Drawer */}
                    <CssBaseline />
                    <Navbar
                      drawerWidth={drawerWidth}
                      onClickMenuButton={() => setIsOpenDrawer(!isOpenDrawer)}
                    />
                    <NavDrawer
                      drawerWidth={drawerWidth}
                      open={isOpenDrawer}
                      onClose={() => setIsOpenDrawer(!isOpenDrawer)}
                    />

                    {/* Content */}
                    <Box
                      component="main"
                      sx={{
                        flexGrow: 1,
                        backgroundImage: `url(${backgroundImage})`,
                        p: { xs: 1, lg: 4 },
                      }}
                    >
                      {/* Espacio para la AppBar */}
                      <Toolbar />

                      <Routes>
                        <Route path="/" element={<Menu />} />
                        <Route path="checkout" element={<Checkout />} />
                        <Route path="voucher/:token" element={<Voucher />} />
                        <Route path="order/:buyOrder" element={<Voucher />} />
                        <Route path="reservation" element={<ReservationPage />} />
                        <Route path="product/:id" element={<ProductDetails />} />
                      </Routes>
                    </Box>
                  </Router>

                </GoogleMapsProvider>
              </CatalogProvider>
            </OrderProvider>
          </UserProvider>
        </ThemeProvider>
      </StyledEngineProvider >
    </Box>
  );
}

export default App;
